import script from "./PolicyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PolicyPage.vue?vue&type=script&setup=true&lang=ts"

import "./PolicyPage.vue?vue&type=style&index=0&id=52640246&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52640246"]])

export default __exports__